import React, { useEffect, useState } from "react";
import API from '../Services/DiscountReason'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

const DiscountReason = () => {
    const [discount, setDiscount] = useState("")
    const [error, setError] = useState({});
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [discountList, setDiscountList] = useState([])
    const [id, setId] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [highlight, setHighlight] = useState(false);
    const [createdDate, setCreatedDate] = useState("")
    const [status, setStatus] = useState("")

    useEffect(() => {
        getDiscountReasonList()
    }, [currentPage])


    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "discount":
                setDiscount(value);
                break;
            default:
                break;
        }
    };

    const validateFields = () => {
        const errors = {};

        if (!discount.trim()) {
            errors.discount = "Discount Reason is required";
        } else if (!/^[a-zA-Z][a-zA-Z0-9 _%-&]*$/.test(discount)) {
            errors.discount = "Enter a valid Discount Reason (must start with a letter)";
        }
        setError(errors);
        return Object.keys(errors).length === 0;
    }
    const addDiscountReason = async () => {
        if (!validateFields()) return;
        const payload = {
            reason: discount,
        }
        try {
            const response = await API.createDiscount(payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Discount Reason successful!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Discount Reason failed.");
            }
        } catch (error) {

            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            if (error.response) {
                const errorMessage =
                    error.response.data?.message || `Error: ${error.response.status}`;
                toast.error(errorMessage);
            } else if (error.request) {
                console.error("Request error:", error.request);
                toast.error("No response from server. Please try again later.");
            } else {
                console.error("Error message:", error.message);
                toast.error("Something went wrong. Please try again.");
            }
        }
    };


    const getDiscountReasonList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getDiscountReason(payload);
            // console.log("response data...", response?.data)
            setDiscountList(response?.data?.data?.rows)
            setTotalRecords(response?.data?.data?.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                // toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };



    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getDiscountReasonList();
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };


    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };


    const changeStatus = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeDiscountStatus(id, updatedStatus);
            if (response.status === 200) {
                setDiscountList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Discount reason ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            console.log("Error in status toggle:", error);
            handleError(error);
        }
    };

    const handleGetData = async (discountId) => {
        try {
            const response = await API.getDiscountReason({ id: discountId });
            const fetchedData = response?.data?.data?.rows?.[0];
            // console.log("fetch data...", fetchedData)
            if (fetchedData) {
                setHighlight(true);
                setId(fetchedData.id);
                setDiscount(fetchedData?.reason)
                setCreatedDate(fetchedData?.createdAt)
                setStatus(fetchedData?.is_active)
                setIsEditing(true);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            } else {
                toast.error("Failed to discount reason point details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const updateDiscountData = async () => {
        try {
            const payload = {
                reason: discount,
            };
            const response = await API.updateDiscountStatus(id, payload);

            if (response?.status === 200) {
                toast.success(response?.data?.message);
                getDiscountReasonList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Refund reason. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            // console.error("Error updating refund :", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }


    const handleSubmit = async () => {
        if (!validateFields()) return;
        if (isEditing) {
            await updateDiscountData();
        } else {
            await addDiscountReason();
        }
    };

    const handleCancel = () => {
        setDiscount('');
        setId(null);
        setIsEditing(false);
    };


    return (
        <div>
            <div >
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div
                            className={`card ${highlight ? "highlight" : ""}`}
                            style={{
                                backgroundColor: highlight ? "#fff" : "white",
                                transition: "background-color 0.3s ease",
                            }}
                        >
                            <div className="card-body">
                                <div className="forms-sample">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="form-group">
                                                <label htmlFor="name">Discount Reason <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtreason"
                                                    placeholder="DiscountReason"
                                                    value={discount}
                                                    onChange={(e) => handleFieldChange(e, "discount")}
                                                />
                                                {error?.discount && (
                                                    <span className="text-danger" style={{ fontSize: "12px" }}>
                                                        {error.discount}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        {!isEditing && (
                                            <button
                                                onClick={handleSubmit}
                                                type="submit"
                                                className="btn btn-primary"
                                            >
                                                Submit
                                            </button>
                                        )}
                                        {isEditing && (
                                            <button
                                                onClick={handleSubmit}
                                                type="submit"
                                                className="btn btn-primary">
                                                Update
                                            </button>
                                        )}
                                        <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Discount Reason</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Discount Reason</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {discountList.map((item, index) => (
                                        // console.log("item....", item),
                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                                          
                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button className="btn btn-primary btn-sm"
                                                                        onClick={() => handleGetData(item.id)}
                                                                    >Edit</button>{' '}
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    {/* {localStorage.getItem("location_id") !== item.id && ( */}
                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>
                                                                    {/* )} */}
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.reason}</td>
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}>
                                            Previous
                                        </button>
                                    </li>
                                
                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`} >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>
            <ToastContainer />
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Discount Reason Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleCancel}></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Discount Reason</th>
                                                            <th>Created Date</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{discount}</td>
                                                            <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                        </tr>
                                                        {/* <tr>
                                                            <td>{getStatus ? "True" : "False"}</td>

                                                            <td>
                                                                {moment(getcreatedAt).format("DD-MM-YYYY")}
                                                            </td>
                                                            <td>
                                                                <img src={logoPreview} alt="Logo" width="50" height="50" />
                                                            </td>
                                                        </tr> */}
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleCancel}>Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default DiscountReason;